import Client from '../axios-client';

const resource = '/message/search-recipient';

export default {
  findRecipient(parameters) {
    return Client.get(`${resource}` + parameters);
  },
};
